import { uuid4 } from './misc'

export const SESSIONID_KEY = '__webtracker_sessionid'

export function getSessionId(): string {
  const sessionIdFromLocalStorage = localStorage.getItem(SESSIONID_KEY)
  if (sessionIdFromLocalStorage) {
    return sessionIdFromLocalStorage
  }
  const uuid = uuid4()
  localStorage.setItem(SESSIONID_KEY, uuid)
  return uuid
}
